export enum BuildingClass {
    ECONOMY = 'ECONOMY',
    COMFORT = 'COMFORT',
    COMFORT_PLUS = 'COMFORT_PLUS',
    BUSINESS = 'BUSINESS',
    ELITE = 'ELITE'
}
